import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { IonPage, IonContent, IonSpinner } from "@ionic/react";
import "./PBHome.css";

import appLogo from "./logo.png";
import healthBenefits from "./healthBenefit.png";
import myAppointment from "./appointment.png";
import healthPlan from "./health-plan.png";
import vitals from "./vitals.png";
import documents from "./documents.png";
import askCard from "./ask-card.png";
import doctorCard from "./doctor-consultation.png";
import assessHealth from "./assess-health.png";
import nutritionCard from "./nutrition-support.png";
import meditationCard from "./meditation.png";
import labTests from "./lab-tests.png";
import medicines from "./medicines.png";
import profileIcon from "./assets/images/Clipped.svg";
import clevertapLogger from "./clevertapLogger";

const PBHome = () => {
  const history = useHistory();
  const [imagesLoaded, setImagesLoaded] = useState(0);

  const totalImages = 11;

  const handleImageLoad = () => {
    setImagesLoaded((prev) => prev + 1);
  };

  const goTo = (path) => {
    history.push(path, { from: "pb-home" });
  };

  const isLoaded = imagesLoaded >= totalImages;

  return (
    <IonPage className="pb-home-page">
      <IonContent fullscreen>
        {!isLoaded && (
          <div className="pb-home-loader">
            <IonSpinner name="crescent" />
          </div>
        )}

        <div style={{ visibility: isLoaded ? "visible" : "hidden" }}>
          {/* HEADER */}
          <div className="pb-home-header">
            <img
              src={appLogo}
              alt="Logo"
              className="pb-home-logo"
              onLoad={handleImageLoad}
            />

            <div className="pb-home-profile" onClick={() => goTo("/profile")}>
              <img src={profileIcon} alt="Profile" onLoad={handleImageLoad} />
            </div>
          </div>

          {/* BODY */}
          <div className="pb-home-body">
            <div className="pb-home-top-grid">
              <img
                src={healthPlan}
                onLoad={handleImageLoad}
                onClick={() => {
                  clevertapLogger.push("pb_open_health_nutrition");
                  goTo("/health-plan");
                }}
              />
              <img
                src={vitals}
                onLoad={handleImageLoad}
                onClick={() => {
                  clevertapLogger.push("pb_open_vital_chart");
                  goTo("/vitals");
                }}
              />
              <img
                src={myAppointment}
                onLoad={handleImageLoad}
                onClick={() => {
                  clevertapLogger.push("pb_open_health_benefits_kyp");
                  goTo("/order-history");
                }}
              />
              <img
                src={documents}
                onLoad={handleImageLoad}
                onClick={() => {
                  clevertapLogger.push("pb_open_documents");
                  goTo("/documents");
                }}
              />
            </div>
            <img
              src={healthBenefits}
              className="pb-home-full"
              onLoad={handleImageLoad}
              onClick={() => {
                clevertapLogger.push("pb_open_health_benefits_kyp");
                goTo("/know-your-plan");
              }}
            />

            <img
              src={askCard}
              className="pb-home-full"
              onLoad={handleImageLoad}
              onClick={() => {
                clevertapLogger.push("pb_open_chat");
                goTo("tab/chat");
              }}
            />

            <img
              src={doctorCard}
              className="pb-home-full"
              onLoad={handleImageLoad}
              onClick={() => {
                clevertapLogger.push("pb_open_doctor_consultation");
                goTo("/navigo?currScreen=1&pageType=4");
              }}
            />

            <div className="pb-home-grid-2">
              <img
                src={assessHealth}
                onLoad={handleImageLoad}
                onClick={() => {
                  clevertapLogger.push("pb_open_assesshealth");
                  goTo("/navigo?currScreen=1&pageType=5");
                }}
              />
              <img
                src={nutritionCard}
                onLoad={handleImageLoad}
                onClick={() => {
                  clevertapLogger.push("pb_open_nutrition_consultation");
                  goTo("/navigo?currScreen=1&pageType=2");
                }}
              />
            </div>

            <img
              src={meditationCard}
              className="pb-home-full"
              onLoad={handleImageLoad}
              onClick={() => {
                clevertapLogger.push("pb_open_meditation");
                goTo("/meditation");
              }}
            />

            <div className="pb-home-grid-2">
              <img
                src={labTests}
                onLoad={handleImageLoad}
                onClick={() => {
                  clevertapLogger.push("pb_open_labtest");
                  goTo("/navigo?currScreen=1&serviceType=2&pageType=3");
                }}
              />
              <img
                src={medicines}
                onLoad={handleImageLoad}
                onClick={() => {
                  clevertapLogger.push("pb_open_medicine");
                  goTo("/medicine");
                }}
              />
            </div>

            <div className="pb-home-footer">Term and condition</div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default PBHome;
